import { cloneElement } from "react";
import XCircleIcon from "@heroicons/react/20/solid/XCircleIcon";

import cx from "@hsl/core/utils/cx";

import { Translate } from "../../../../../hooks/useTranslation";

interface DetailFormInputProps {
    icon: React.ReactElement<{
        className?: string;
    }>;
    children: React.ReactNode;
    className?: string;
}

export function DetailFormInput({
    icon,
    children,
    className,
}: DetailFormInputProps) {
    return (
        <div className={cx("flex gap-4", className)}>
            <div className="mt-3 flex h-6 w-6 shrink-0">
                {cloneElement(icon, {
                    className: cx(
                        "text-l-g-blue w-full h-full",
                        icon.props.className,
                    ),
                })}
            </div>
            <div className="[&>input]:border-taupe-grey flex max-w-xs flex-1 flex-col gap-4 [&>input]:w-full [&>input]:rounded-sm [&>input]:border [&>input]:px-4 [&>input]:py-2.5">
                {children}
            </div>
        </div>
    );
}

interface InvalidInputProps {
    error?: { message?: string };
}

export const InvalidInput = ({ error }: InvalidInputProps) => {
    if (!error) return null;

    return (
        <div
            className={cx("text-core-red inline-flex items-start py-1 text-sm")}
        >
            <XCircleIcon width={16} className="mr-2 mt-0.5 inline shrink-0" />
            <p role="alert">
                <Translate>{error.message ?? ""}</Translate>
            </p>
        </div>
    );
};
